import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText, FormGroup, Label, Input, CloseButton, Spinner } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { ITopic } from 'app/shared/model/topic.model';
import { getEntities as getTopics } from 'app/entities/topic/topic.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IInspiration } from 'app/shared/model/inspiration.model';
import axios from 'axios';
import { INewsFeed } from 'app/shared/model/news-feed.model';
import { IAnnouncement } from 'app/shared/model/announcement.model';
import { createEntity, updateEntity } from './announcement.reducer';

export const AnnouncementUpdate = props => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const id = props.inspirationId;
  const isNew = id === null;
  const users = useAppSelector(state => state.userManagement.users);
  const announcementData = useAppSelector(state => state.announcement.entities);
  const [announcementList, setannouncementList] = useState<IAnnouncement | null>(null);
  const loading = useAppSelector(state => state.inspiration.loading);
  const [error, setError] = useState('');
  const [announcement, setAnnouncement] = useState('');
  const [apiError, setApiError] = useState('');
  const updating = useAppSelector(state => state.announcement.updating);
  const updateSuccess = useAppSelector(state => state.announcement.updateSuccess);
  const [mediaPreview, setMediaPreview] = useState('');
  const [uploadedMedia, setUploadedMedia] = useState(null);
  const baseImageUrl = '/image';
  const account = useAppSelector(state => state.authentication.account);
  const userid = account.id;
  const [imageName, setImageName] = useState(null);
  const handleClose = () => {
    props.handleSubmit();
  };

  useEffect(() => {
    dispatch(getTopics({}));
    dispatch(getUsers({}));
  }, []);
  useEffect(() => {
    if (isNew) {
    } else {
      if (Array.isArray(announcementData)) {
        const announcementDataArray = announcementData.filter(item => item.id === id) as IInspiration[];
        if (announcementDataArray.length > 0) {
          const newsFeedListDataItem = announcementDataArray[0];
          setannouncementList(newsFeedListDataItem);
          // dispatch(getEntity(id));
        } else {
        }
      } else {
      }
    }
  }, [isNew, id, announcementData]);
  // useEffect(() => {
  //   if (updateSuccess) {
  //     handleClose();
  //   }
  // }, [updateSuccess]);
  useEffect(() => {
    if (announcementList?.imageName) {
      setMediaPreview(`${baseImageUrl}/${announcementList?.imageName}`);
      setImageName(announcementList?.imageName);
    }
    if (announcementList?.description) {
      setAnnouncement(announcementList.description);
    }
  }, [announcementList]);

  const handleMediaFileInputChange = event => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const formData = new FormData();
      formData.append('image', selectedFile);

      const uploadUrl = selectedFile.type.startsWith('video/') ? '/api/upload?type=video' : '/api/upload/';

      axios
        .post(uploadUrl, formData)
        .then(response => {
          const fullMediaUrl = `${baseImageUrl}/${response.data}`;
          setMediaPreview(fullMediaUrl);
          setImageName(response.data);
          setUploadedMedia(response.data);
          setError('');
        })
        .catch(error => {
          setError('Error uploading image/video. Please try again.');
          console.error('Error uploading media:', error);
        });
    }
  };

  const handleRemoveMedia = () => {
    setMediaPreview('');
    setUploadedMedia(null);
    setImageName('');
  };
  const saveEntity = async values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    if (!isNew) {
      values.modifiedDate = new Date();
    }
    const entity = {
      ...announcementList,
      ...values,
      imageName: imageName !== '' ? imageName || announcementList?.imageName : null,
      //topics: topicsString,
      user: { id: userid },
    };

    if (isNew) {
      const resultAction = await dispatch(createEntity(entity));
      if (createEntity.fulfilled.match(resultAction)) {
        handleClose();
      } else if (createEntity.rejected.match(resultAction)) {
        const errorMessage = resultAction.payload as string;
        if (errorMessage) {
          setApiError(errorMessage);
        }
      }
    } else {
      await dispatch(updateEntity(entity));
      handleClose();
    }
  };
  const handleAnnouncementChange = value => {
    setAnnouncement(value);
    setError('');
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: new Date(),
        }
      : {
          ...announcementList,
          description: announcement,
          modifiedDate: convertDateTimeFromServer(new Date()),
          imageName: imageName != '' ? imageName || announcementList?.imageName : null,
          user: announcementList?.user?.id,
        };
  return (
    <div className="card meeting-border edit-create-pages">
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.news.home.createOrEditLabel" data-cy="newsCreateUpdateHeading">
            <label>Add or Edit Announcement</label>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <Spinner className="body-loader-icon"></Spinner>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              <ValidatedField
                label={'Description'}
                id="news-feed-description"
                name="description"
                data-cy="description"
                type="textarea"
                value={announcement}
                onChange={e => handleAnnouncementChange(e.target.value)}
                placeholder={`Enter your Announcement`}
                required
              />
              {error && <div className="text-danger">{error}</div>}
              <ValidatedField
                id="media-file"
                name="mediaFile"
                data-cy="mediaFile"
                type="file"
                label={'Upload Image or Video'}
                className="col-12 col-md-6 col-lg-4 position-relative"
                onChange={handleMediaFileInputChange}
              />
              {mediaPreview && (
                <Col md={12}>
                  <div className="remove-media-btn">
                    <CloseButton onClick={handleRemoveMedia} />
                    {mediaPreview.endsWith('.mp4') ? (
                      <video controls className="mb-4 p-0">
                        <source src={mediaPreview} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <img className="img-thumbnail mb-4 p-0" src={mediaPreview} alt="Media Preview" />
                    )}
                  </div>
                </Col>
              )}
              {apiError && <div className="text-danger">{apiError}</div>}
              &nbsp;
              <ValidatedField
                label={translate('fivePlusApp.newsFeed.link')}
                id="news-feed-link"
                name="link"
                data-cy="link"
                type="text"
                validate={{
                  pattern: {
                    value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                    message: 'Please enter a valid URL',
                  },
                }}
              />
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Submit</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AnnouncementUpdate;
